import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
import { BaseCase } from '../../../basecase';
import { PlatformLocation} from '@angular/common';
declare var app;

@Component({
  selector: 'app-sfa-list-score',
  templateUrl: './sfa-list-score.component.html',
  styleUrls: ['./sfa-list-score.component.scss']
})
export class SfaListScoreComponent extends GridBaseCase {
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  constructor( 
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    private platformlocation:PlatformLocation) { super(); }


    loadMoreData(event) {
      let that = this;
      if (that.RecordCount == that.dataArrayList.length) {
        that.infiniteScroll.disabled = true;
      } else {
        that.PageNumber++;
        this.LoadData(that.PageNumber);
      }
    }

    LoadData(PageNumber) {
      const that = this;
      that.PageNumber = PageNumber;
      if (PageNumber == 1) {
        that.loading = false;
        that.apiObj['status'] = false;
        that.apiObj['msg'] = '';
      }
  
      const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body: WebParameterContext = new WebParameterContext();
      if (that.element.selectItemList.gridViewConfigName) {
        body.ConfigName = that.element.selectItemList.gridViewConfigName;
      } else if (that.ConfigName) {
        body.ConfigName = that.ConfigName;
      }
      body.Account = that.com.GetAccount;
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = PageNumber;
      body.Client.Name = pageName;
      body.Client.PageName = pageName;
      // body = HandleWebParameterContextBeforeDBRequest(body);
      // if (!body.ResponseMessage.Success) {
      //   that.msg.Alert(body.ResponseMessage.ErrorMessage);
      //   return;
      // }
      body.RequestBody=JSON.stringify({"a_FK_Store_ID":that.com.GetStorageKey("tbstore").ID});
      that.http.post(app.DEFAULTURL, body).then(data => {
      console.log(data);
        // data = HandleServerContextAfterDBRequest(body, data);
        /****判断是否第一页begin****/
        if(PageNumber == 1){
          that.dataArrayList = [];
          that.apiObj['status'] = data.ResponseMessage.Success;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        }else{
          that.infiniteScroll.complete();
        }
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
          data.Status.Datas.forEach(function (item) {
            let objfield = {};
            that.element.selectItemList.selectItem.forEach((element, index) => {
              if (element.bindingField) {
                objfield[element.bindingField] = item[element.field];
              }
            });
            that.dataArrayList.push(objfield);
          });
          // console.log(that.dataArrayList);
          /****上拉加载数据begin****/
          that.RecordCount = data.Status.RecordCount;
          if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
            that.infiniteScroll.disabled = true;
          }else{
            that.infiniteScroll.disabled = false;
          }
          /****上拉加载数据end****/
        } else {
          console.log(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        that.loading = true;
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
  
        console.log(error);
      })
    }
    EventLink(ev: any, parms: any) {
      let evs = ev.url || '';      
      const pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
      const storeid=this.com.GetStorageKey("tbstore").ID;
      if (evs.trim() && parms) {
        if (evs.indexOf("http") > 0) {
        } else {
          this.com.setHistoryUrl();
          if(pageName=="CommentList")
          {
            var  type="add";
            var id=parms.id;
            if(parms.scoreStatus)
            {
              type="edite";
              id=parms.scoreStatus;
            }
            // this.router.navigateByUrl(evs +type+"/" + id);
            this.com.Go(evs +type+"/" + id);
          }else
          {
          // this.router.navigateByUrl(evs + "/" + parms.id);
          this.com.Go(evs + "/" + parms.id);
          }
        }
      }
  
    }
}
